import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import { ThemeProvider } from 'emotion-theming'
import theme from '../theme'
import styled from 'react-emotion'

import '../assets/fonts/stylesheet.css'
import '../assets/css/index.css'

import Footer from '../components/Common/Footer'
import PageContent from '../components/Common/PageContent'
import Header from '../components/Common/Header'

const SiteBackground = styled.div`
  background-color: ${props => props.theme.backgroundColor};
  overflow-x: hidden;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;

  h1,
  hr {
    font-family: ${props => props.theme.serifFont};
    @media (min-width: 768px) {
      margin-left: 0;
      margin-right: 0;
    }
  }

  h1 {
    font-size: 38px;
  }
  h2 {
    font-size: 22px;
  }
  h3 {
    font-size: 19px;
  }
  h4 {
    font-size: 17px;
  }
  h5 {
    font-size: 15px;
  }
  h6 {
    font-size: 12px;
  }

  & > div {
    @media (min-width: 768px) {
      margin-left: 0;
      margin-right: 0;
    }
  }

  .sr-only {
    display: none;

    @media speech {
      display: inline;
    }
  }
`

const TemplateWrapper = ({ children }) => (
  <ThemeProvider theme={theme}>
    <SiteBackground>
      <Helmet>
        <title>Hardin Therapeutic Services</title>
        <meta
          name="description"
          content="Hardin Therapeutic Services offers in person centered therapy with specialties in grief and trauma."
        />
        <meta
          name="keywords"
          content="therapy, grief, trauma, couples, ocd, counseling, sadness, anger"
        />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="/apple-touch-icon.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href="/favicon-32x32.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href="/favicon-16x16.png"
        />
        <link rel="manifest" href="/site.webmanifest" />
        <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#5bbad5" />
        <meta name="msapplication-TileColor" content="#da532c" />
        <meta name="theme-color" content="#ffffff" />
      </Helmet>
      <Header />
      {children()}
      <Footer />
    </SiteBackground>
  </ThemeProvider>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js